import { render, staticRenderFns } from "./JournalModal.vue?vue&type=template&id=e882aeb2"
import script from "./JournalModal.vue?vue&type=script&lang=js"
export * from "./JournalModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports